import Vuex from "vuex";
import Vue from "vue";

import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

import * as user from "@/store/modules/User";
import * as cart from "@/store/modules/Cart";
import * as passTypes from "@/store/modules/PassTypes";
import * as ads from "@/store/modules/Ads";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    cart,
    passTypes,
    ads
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, { expires: 3, secure: true }),
        removeItem: key => Cookies.remove(key)
      },
      paths: ["cart"]
    })
  ]
});
